import { render, staticRenderFns } from "./MenuChecks.vue?vue&type=template&id=db673d3e&scoped=true&"
import script from "./MenuChecks.vue?vue&type=script&lang=js&"
export * from "./MenuChecks.vue?vue&type=script&lang=js&"
import style0 from "./MenuChecks.vue?vue&type=style&index=0&id=db673d3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db673d3e",
  null
  
)

export default component.exports